import { IReduxState } from 'types/redux';

export const categoriesVisibilitySelector = (state: IReduxState) => state.categories.categoriesVisibility;

export const categoriesSelector = (state: IReduxState) => state.categories.general;

export const categoriesGroupingsSelector = (state: IReduxState) => state.categories.groupings;

export const assetTypesSelector = (state: IReduxState) => state.categories.assetTypes;
